// clickSound.js — Premium UI click via Web Audio API
// ~80ms duration, 12% master volume, plays only on interactive elements

let audioCtx = null;
let initialized = false;

function getAudioContext() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioCtx;
}

function playClick() {
  try {
    const ctx = getAudioContext();
    if (ctx.state === 'suspended') {
      ctx.resume();
    }

    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();

    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(1800, ctx.currentTime);
    oscillator.frequency.exponentialRampToValueAtTime(600, ctx.currentTime + 0.08);

    gainNode.gain.setValueAtTime(0.12, ctx.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.08);

    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);

    oscillator.start(ctx.currentTime);
    oscillator.stop(ctx.currentTime + 0.08);
  } catch (e) {
    // Silent fail
  }
}

function isInteractiveClick(target) {
  let el = target;
  for (let i = 0; i < 6; i++) {
    if (!el || el === document) return false;
    if (el.tagName === 'BUTTON') return true;
    if (el.tagName === 'A' && (
      el.classList.contains('btn-primary') ||
      el.classList.contains('btn-secondary') ||
      el.classList.contains('inline-flex') ||
      el.closest('nav, header, footer')
    )) return true;
    if (el.getAttribute && (
      el.getAttribute('role') === 'button' ||
      (el.getAttribute('data-testid') || '').match(/cta|btn|link/)
    )) return true;
    el = el.parentElement;
  }
  return false;
}

export function initClickSound() {
  if (initialized) return;
  initialized = true;

  document.addEventListener('click', (e) => {
    if (isInteractiveClick(e.target)) {
      playClick();
    }
  }, { passive: true, capture: true });

  // Resume AudioContext on first touch for mobile
  document.addEventListener('touchstart', () => {
    const ctx = getAudioContext();
    if (ctx.state === 'suspended') ctx.resume();
  }, { passive: true, once: true });
}
